"use client";
import React from "react";
import styles from "./ErrorComponent.module.scss";
import Locale from "@/app/locales";
interface IProps {
  errorMsg: string;
  canRetry?: boolean;
}
export default function ErrorPage(props: IProps) {
  const message = props.errorMsg || Locale.error.pageError;
  const canRetry = props.canRetry === undefined ? true : props.canRetry;
  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorIcon}>
        <svg
          style={{ fontSize: "64px", color: "#ff4d4f" }}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          focusable="false"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="m10.23 2.4-8.7 16.67A2 2 0 0 0 3.3 22h17.4a2 2 0 0 0 1.77-2.93L13.77 2.4a2 2 0 0 0-3.54 0ZM13.14 14a1.15 1.15 0 0 1-2.28 0l-.58-4.03a1.73 1.73 0 1 1 3.44 0l-.58 4.03Zm.36 4.49a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
      <h1 className={styles.errorTitle}>{Locale.error.errorVisible}</h1>
      <p className={styles.errorMessage}>{message}</p>
      <div className={styles.buttonGroup}>
        {canRetry && (
          <button
            className={`${styles.button} ${styles.primary}`}
            onClick={() => {
              window.location.reload();
            }}
          >
            {Locale.error.reload}
          </button>
        )}
      </div>
    </div>
  );
}
